import PropTypes from 'prop-types'
import IconButton from './icon-button'

export default function CloseButton({ onClick, ...props }) {
  return (
    <IconButton onClick={onClick} icon="times" data-testid="close-button" />
  )
}

CloseButton.propTypes = {
  onClick: PropTypes.func,
}
